const DEFAULT_STORE_BASE_URL = 'https://zwheel-shop.com';

export const STORE_HOME_URL = (process.env.REACT_APP_STORE_BASE_URL || DEFAULT_STORE_BASE_URL).replace(/\/+$/, '');

function buildStoreUrl(path: string) {
  return `${STORE_HOME_URL}${path.startsWith('/') ? path : `/${path}`}`;
}

function buildStoreCategoryUrl(path: string) {
  return buildStoreUrl(`/product-category/${path}`);
}

const PRODUCT_CATEGORY_BASE_PATH = 'patinetes-electricos';
const ACCESSORY_CATEGORY_BASE_PATH = 'accessorios';
const PART_CATEGORY_BASE_PATH = 'piezas-de-repuesto';

const PRODUCT_LINE_CATEGORY_PATHS: Record<string, string> = {
  zcougar: `${PRODUCT_CATEGORY_BASE_PATH}/zcougar`,
  zfox: `${PRODUCT_CATEGORY_BASE_PATH}/zfox`,
  zlion: `${PRODUCT_CATEGORY_BASE_PATH}/zlion`,
  zrino: `${PRODUCT_CATEGORY_BASE_PATH}/zrion`,
  ztoy: PRODUCT_CATEGORY_BASE_PATH,
  zwolf: `${PRODUCT_CATEGORY_BASE_PATH}/zwolf`
};

const PRODUCT_MODEL_PATHS: Record<string, string> = {
  zwolf: '/product/zwolf/',
  'zwolf-duo': '/product/zwolf-duo/',
  'zwolf-plus': '/product/zwolf-plus/',
  zcougar: '/product/zcougar/',
  'zcougar-duo': '/product/zcougar-duo/',
  'zcougar-plus': '/product/zcougar-plus/',
  'zrino-se': '/product/zrino-se/',
  'zrino-duo': '/product/zrino-duo/',
  'zrino-duo-max': '/product/zrino-duo-max/',
  'zlion-pro': '/product/zlion-pro/',
  'zlion-x': '/product/zlion-x/',
  'zfox-max': '/product/zfox-max/',
  'zfox-plus': '/product/zfox-plus/'
};

export const STORE_SCOOTERS_URL = buildStoreCategoryUrl(PRODUCT_CATEGORY_BASE_PATH);
export const STORE_ACCESSORIES_URL = buildStoreCategoryUrl(ACCESSORY_CATEGORY_BASE_PATH);
export const STORE_PARTS_URL = buildStoreCategoryUrl(PART_CATEGORY_BASE_PATH);

export interface CatalogCategory {
  id: string;
  name: string;
  description: string;
  count: number;
  type: 'accessory' | 'part';
  shopUrl: string;
  image: string;
}

export interface FinderModel {
  id: string;
  label: string;
  description: string;
  shopUrl: string;
}

export interface FinderFamily {
  id: string;
  name: string;
  description: string;
  image: string;
  models: FinderModel[];
}

export interface LineExperienceConfig {
  accessoryCategoryIds: string[];
  partCategoryIds: string[];
  useCases: string[];
}

export const ACCESSORY_CATEGORIES: CatalogCategory[] = [
  {
    id: 'proteccion-seguridad',
    name: 'Proteccion y seguridad',
    description: 'Cascos, cierres y soluciones para circular con mas confianza.',
    count: 58,
    type: 'accessory',
    shopUrl: buildStoreCategoryUrl(`${ACCESSORY_CATEGORY_BASE_PATH}/proteccion-y-seguridad`),
    image: '/images/access/Proteccion-y-seguridad.jpg'
  },
  {
    id: 'personalizacion',
    name: 'Personalizacion',
    description: 'Accesorios visuales y funcionales para dar un toque propio a tu Zwheel.',
    count: 14,
    type: 'accessory',
    shopUrl: buildStoreCategoryUrl(`${ACCESSORY_CATEGORY_BASE_PATH}/personalizacion`),
    image: '/images/access/Personalizacion.jpg'
  },
  {
    id: 'ruedas-accesorios',
    name: 'Ruedas',
    description: 'Opciones centradas en agarre, confort y preparacion para distintos recorridos.',
    count: 49,
    type: 'accessory',
    shopUrl: buildStoreCategoryUrl(`${ACCESSORY_CATEGORY_BASE_PATH}/ruedas`),
    image: '/images/access/Ruedas.jpg'
  },
  {
    id: 'transporte-almacenamiento',
    name: 'Transporte y almacenamiento',
    description: 'Soluciones para guardar, mover y proteger tu patinete fuera de la ruta.',
    count: 4,
    type: 'accessory',
    shopUrl: buildStoreCategoryUrl(`${ACCESSORY_CATEGORY_BASE_PATH}/transporte-y-almacenamiento`),
    image: '/images/access/transporte-almacenamiento.jpg'
  },
  {
    id: 'otros-accesorios',
    name: 'Otros accesorios',
    description: 'Complementos utiles para ampliar la experiencia Zwheel.',
    count: 5,
    type: 'accessory',
    shopUrl: buildStoreCategoryUrl(`${ACCESSORY_CATEGORY_BASE_PATH}/otros-accesorios`),
    image: '/images/access/otros-accesorios.jpg'
  }
];

export const PART_CATEGORIES: CatalogCategory[] = [
  {
    id: 'baterias-cargadores',
    name: 'Baterias y cargadores',
    description: 'Baterias, cargadores y elementos clave para mantener la autonomia.',
    count: 24,
    type: 'part',
    shopUrl: buildStoreCategoryUrl(`${PART_CATEGORY_BASE_PATH}/baterias-y-cargadores`),
    image: '/images/access/1.jpg'
  },
  {
    id: 'chasis-estructura',
    name: 'Chasis y estructura',
    description: 'Manillares, mastiles y piezas estructurales para mantener el conjunto estable.',
    count: 96,
    type: 'part',
    shopUrl: buildStoreCategoryUrl(`${PART_CATEGORY_BASE_PATH}/chasis-y-estructura`),
    image: '/images/access/2.jpg'
  },
  {
    id: 'electronica-motor',
    name: 'Electronica y motor',
    description: 'Centralitas, cableado, motores y componentes de propulsion.',
    count: 89,
    type: 'part',
    shopUrl: buildStoreCategoryUrl(`${PART_CATEGORY_BASE_PATH}/electronica-y-motor`),
    image: '/images/access/3.jpg'
  },
  {
    id: 'frenado-suspension',
    name: 'Frenado y suspension',
    description: 'Discos, pinzas, amortiguacion y piezas para recuperar control y confort.',
    count: 57,
    type: 'part',
    shopUrl: buildStoreCategoryUrl(`${PART_CATEGORY_BASE_PATH}/frenado-y-suspension`),
    image: '/images/access/4.jpg'
  },
  {
    id: 'guardabarros-cubiertas',
    name: 'Guardabarros y cubiertas',
    description: 'Piezas exteriores para proteccion, acabado y mantenimiento del conjunto.',
    count: 48,
    type: 'part',
    shopUrl: buildStoreCategoryUrl(`${PART_CATEGORY_BASE_PATH}/guardabarros-y-cubiertas`),
    image: '/images/access/5.jpg'
  },
  {
    id: 'iluminacion',
    name: 'Iluminacion',
    description: 'Faros, pilotos e intermitentes para seguir viendo y siendo visto.',
    count: 34,
    type: 'part',
    shopUrl: buildStoreCategoryUrl(`${PART_CATEGORY_BASE_PATH}/iluminacion`),
    image: '/images/access/6.jpg'
  },
  {
    id: 'ruedas-camaras',
    name: 'Ruedas y camaras',
    description: 'Neumaticos, camaras y elementos de rodadura para mantener el rendimiento.',
    count: 50,
    type: 'part',
    shopUrl: buildStoreCategoryUrl(`${PART_CATEGORY_BASE_PATH}/ruedas-y-camaras`),
    image: '/images/access/7.jpg'
  },
  {
    id: 'tornilleria',
    name: 'Tornilleria y pequenas piezas',
    description: 'Piezas de fijacion y pequeños consumibles para reparaciones precisas.',
    count: 23,
    type: 'part',
    shopUrl: buildStoreCategoryUrl(`${PART_CATEGORY_BASE_PATH}/tornilleria-y-pequenas-piezas`),
    image: '/images/access/8.jpg'
  }
];

export const FINDER_FAMILIES: FinderFamily[] = [
  {
    id: 'zwolf',
    name: 'ZWolf',
    description: 'Serie todoterreno y de alto rendimiento.',
    image: '/images/product/zwolf/cover.png',
    models: [
      {
        id: 'zwolf',
        label: 'ZWolf',
        description: 'Acceso a la categoria ZWolf en la tienda oficial.',
        shopUrl: buildStoreCategoryUrl(PRODUCT_LINE_CATEGORY_PATHS.zwolf)
      },
      {
        id: 'zwolf-plus',
        label: 'ZWolf Plus',
        description: 'Acceso a la categoria ZWolf en la tienda oficial.',
        shopUrl: buildStoreCategoryUrl(PRODUCT_LINE_CATEGORY_PATHS.zwolf)
      },
      {
        id: 'zwolf-duo',
        label: 'ZWolf Duo',
        description: 'Acceso a la categoria ZWolf en la tienda oficial.',
        shopUrl: buildStoreCategoryUrl(PRODUCT_LINE_CATEGORY_PATHS.zwolf)
      }
    ]
  },
  {
    id: 'zcougar',
    name: 'ZCougar',
    description: 'Gama asfaltica de alto rendimiento con gran autonomia.',
    image: '/images/product/zcougar/cover.png',
    models: [
      {
        id: 'zcougar',
        label: 'ZCougar - PZ0007',
        description: 'Acceso a la categoria ZCougar en la tienda oficial.',
        shopUrl: buildStoreCategoryUrl(PRODUCT_LINE_CATEGORY_PATHS.zcougar)
      },
      {
        id: 'zcougar-plus',
        label: 'ZCougar Plus - PZ0008',
        description: 'Acceso a la categoria ZCougar en la tienda oficial.',
        shopUrl: buildStoreCategoryUrl(PRODUCT_LINE_CATEGORY_PATHS.zcougar)
      },
      {
        id: 'zcougar-duo',
        label: 'ZCougar Duo - PZ0006',
        description: 'Acceso a la categoria ZCougar en la tienda oficial.',
        shopUrl: buildStoreCategoryUrl(PRODUCT_LINE_CATEGORY_PATHS.zcougar)
      }
    ]
  },
  {
    id: 'zrino',
    name: 'ZRino',
    description: 'Serie equilibrada para recorridos largos y uso mixto.',
    image: '/images/product/zrino/cover.png',
    models: [
      {
        id: 'zrino-se',
        label: 'ZRino SE / ZRino SE - PZ0019',
        description: 'Acceso a la categoria ZRino en la tienda oficial.',
        shopUrl: buildStoreCategoryUrl(PRODUCT_LINE_CATEGORY_PATHS.zrino)
      },
      {
        id: 'zrino-duo',
        label: 'ZRino DUO - PZ0005',
        description: 'Acceso a la categoria ZRino en la tienda oficial.',
        shopUrl: buildStoreCategoryUrl(PRODUCT_LINE_CATEGORY_PATHS.zrino)
      },
      {
        id: 'zrino-duo-max',
        label: 'ZRino Duo Max - PZ0021',
        description: 'Acceso a la categoria ZRino en la tienda oficial.',
        shopUrl: buildStoreCategoryUrl(PRODUCT_LINE_CATEGORY_PATHS.zrino)
      }
    ]
  },
  {
    id: 'zlion',
    name: 'ZLion',
    description: 'Gama urbana con enfoque equilibrado entre confort y potencia.',
    image: '/images/product/zlion/cover.png',
    models: [
      {
        id: 'zlion-x',
        label: 'ZLion X - PZ0003',
        description: 'Acceso a la categoria ZLion en la tienda oficial.',
        shopUrl: buildStoreCategoryUrl(PRODUCT_LINE_CATEGORY_PATHS.zlion)
      },
      {
        id: 'zlion-pro',
        label: 'ZLion Pro - PZ0025',
        description: 'Acceso a la categoria ZLion en la tienda oficial.',
        shopUrl: buildStoreCategoryUrl(PRODUCT_LINE_CATEGORY_PATHS.zlion)
      }
    ]
  },
  {
    id: 'zfox',
    name: 'ZFox',
    description: 'Serie ligera para el dia a dia urbano.',
    image: '/images/product/zfox/cover.png',
    models: [
      {
        id: 'zfox-plus',
        label: 'ZFox Plus - PZ0002',
        description: 'Acceso a la categoria ZFox en la tienda oficial.',
        shopUrl: buildStoreCategoryUrl(PRODUCT_LINE_CATEGORY_PATHS.zfox)
      },
      {
        id: 'zfox-max',
        label: 'ZFox Max',
        description: 'Acceso a la categoria ZFox en la tienda oficial.',
        shopUrl: buildStoreCategoryUrl(PRODUCT_LINE_CATEGORY_PATHS.zfox)
      }
    ]
  },
  {
    id: 'ztoy',
    name: 'ZToy',
    description: 'Patinete infantil para primeras aventuras con manejo simple y enfoque seguro.',
    image: '/images/product/ztoy/cuadara-azul.png',
    models: [
      {
        id: 'ztoy-superkid',
        label: 'ZToy Superkid',
        description: 'Acceso a la gama infantil Zwheel en la tienda oficial.',
        shopUrl: buildStoreCategoryUrl(PRODUCT_LINE_CATEGORY_PATHS.ztoy)
      }
    ]
  }
];

export const LINE_EXPERIENCE: Record<string, LineExperienceConfig> = {
  zwolf: {
    accessoryCategoryIds: ['proteccion-seguridad', 'ruedas-accesorios', 'transporte-almacenamiento'],
    partCategoryIds: ['baterias-cargadores', 'frenado-suspension', 'ruedas-camaras'],
    useCases: ['Rutas exigentes', 'Pendientes pronunciadas', 'Trayectos largos con potencia']
  },
  zcougar: {
    accessoryCategoryIds: ['proteccion-seguridad', 'personalizacion', 'ruedas-accesorios'],
    partCategoryIds: ['frenado-suspension', 'electronica-motor', 'ruedas-camaras'],
    useCases: ['Desplazamientos urbanos rapidos', 'Uso diario con autonomia alta', 'Usuarios que buscan confort y respuesta']
  },
  zrino: {
    accessoryCategoryIds: ['proteccion-seguridad', 'ruedas-accesorios', 'otros-accesorios'],
    partCategoryIds: ['baterias-cargadores', 'guardabarros-cubiertas', 'ruedas-camaras'],
    useCases: ['Movilidad mixta ciudad y extrarradio', 'Trayectos de media y larga distancia', 'Usuarios que priorizan equilibrio general']
  },
  zlion: {
    accessoryCategoryIds: ['proteccion-seguridad', 'personalizacion', 'transporte-almacenamiento'],
    partCategoryIds: ['electronica-motor', 'frenado-suspension', 'iluminacion'],
    useCases: ['Commuting urbano', 'Uso frecuente entre semana', 'Usuarios que quieren equilibrio entre tamaño y rendimiento']
  },
  zfox: {
    accessoryCategoryIds: ['proteccion-seguridad', 'transporte-almacenamiento', 'otros-accesorios'],
    partCategoryIds: ['baterias-cargadores', 'guardabarros-cubiertas', 'ruedas-camaras'],
    useCases: ['Primer patinete electrico', 'Desplazamientos diarios ligeros', 'Guardado facil en casa o trabajo']
  },
  ztoy: {
    accessoryCategoryIds: ['proteccion-seguridad', 'personalizacion', 'otros-accesorios'],
    partCategoryIds: ['guardabarros-cubiertas', 'iluminacion', 'ruedas-camaras'],
    useCases: ['Primeras rutas en parques y jardines', 'Ninos y ninas desde 6 anos', 'Uso recreativo en entornos seguros']
  }
};

export function getProductShopUrl(lineId: string, productId?: string) {
  if (productId && PRODUCT_MODEL_PATHS[productId]) {
    return buildStoreUrl(PRODUCT_MODEL_PATHS[productId]);
  }

  const categoryPath = PRODUCT_LINE_CATEGORY_PATHS[lineId] ?? PRODUCT_CATEGORY_BASE_PATH;
  return buildStoreCategoryUrl(categoryPath);
}

export function getAccessoryCategoryById(categoryId: string) {
  return ACCESSORY_CATEGORIES.find((category) => category.id === categoryId);
}

export function getPartCategoryById(categoryId: string) {
  return PART_CATEGORIES.find((category) => category.id === categoryId);
}

export function getFinderModelByProductId(productId: string) {
  for (const family of FINDER_FAMILIES) {
    const model = family.models.find((item) => item.id === productId);
    if (model) {
      return model;
    }
  }

  return undefined;
}
